import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";

import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import "ag-grid-community/styles/ag-theme-quartz.css";
import axios from "axios";

//import { MyUrl } from "../../../App";
import edit from "../../Images/edit.png";
import delete77 from "../../Images/delete77.png";

export default function RTBManagementFirstTable({
  onSendDataForDelete,
  onSendData,
  SendDataToFirstTable,
  startDate,
  endDate,
}) {
  const [changes, setChanges] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [LoadingUpdateRtbItemsButton, setLoadingUpdateRtbItemsButton] =
    useState(true);

  // Function to handle cell value changes
  const onCellValueChanged = (params) => {
    const { data } = params;
    setChanges((prevChanges) => ({ ...prevChanges, [data.id]: data }));
  };

  // Function to save changes
  const saveChanges = () => {
    const updatedObjects = Object.values(changes);
    console.log("Saving these changes:", updatedObjects);
    // Process saving logic here, such as updating a backend or state
  };

  const gridRef = useRef(); // Optional - for accessing Grid's API
  useEffect(() => {
    // Function to clear cell focus
    const clearCellFocus = () => {
      const gridApi = gridRef.current.api;
      gridApi.clearFocusedCell(); // Clear the focused cell
    };
    // Add click event listener to document
    document.addEventListener("click", clearCellFocus);
    // Cleanup function to remove event listener
    return () => {
      document.removeEventListener("click", clearCellFocus);
    };
  }, []);
  const [rowData, setRowData] = useState(); // Set rowData to Array of Objects, one Object per Row
  function useWindowSize() {
    const [size, setSize] = useState([window.innerHeight, window.innerWidth]);
    useEffect(() => {
      const handleResize = () => {
        setSize([window.innerHeight, window.innerWidth]);
      };
      window.addEventListener("resize", handleResize);
    }, []);
    return size;
  }
  const [height, width] = useWindowSize();
  const [dataToSend, setDataToSend] = useState("True");
  const [dataToSendForDelete, setdataToSendForDelete] = useState("True");

  const handleButtonClick = (
    advertiserId,
    campaignId,
    environment,
    id,
    inputs,
    seatId
  ) => {
    onSendData(changes);
  };

  const handleButtonClickForDelete = (data) => {
    onSendDataForDelete(data);
  };

  const BtnCellRenderer = (rowData) => {
    const [inputs, setInputs] = useState(rowData.data.inappRtbCap);
    const handleChangesetInputs = (event, id) => {
      const updatedValue = event.target.value;
      setInputs(updatedValue); // Update the local state for the input field

      // Update the global changes state with the new value for this specific row
      setChanges((prevChanges) => ({
        ...prevChanges,
        [id]: {
          ...prevChanges[id],
          id: rowData.data.id,
          newValue: updatedValue, // Assuming 'inappRtbCap' is the field you want to update
          env: rowData.data.environment,
          advertiserId: rowData.data.advertiserId,
          campaignId: rowData.data.campaignId,
          seatId: rowData.data.seatId,
        },
      }));
    };

    return (
      <div
        style={{
          backgroundColor: inputs === rowData.data.inappRtbCap ? "" : "#bbf7d0",
        }}
      >
        <a
          style={{
            borderWidth: 0,
            color: "green",
            cursor: "pointer",
            justifyContent: "center",
            alignItems: "center",
          }}
          onClick={() => {
            handleButtonClick(
              rowData.data.advertiserId,
              rowData.data.campaignId,
              rowData.data.environment,
              rowData.data.id,
              inputs,
              rowData.data.seatId
            );
          }}
        >
          <input
            type="text"
            value={inputs}
            onChange={(event) => handleChangesetInputs(event, rowData.data.id)} // Pass the row ID as well
          ></input>
        </a>
      </div>
    );
  };

  console.log(changes);
  // Each Column Definition results in one Column.
  const [columnDefs, setColumnDefs] = useState([
    {
      headerName: "Seat Name",
      flex: width > 766 ? 1 : null,
      field: "seatName",
      filter: true,
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
    },
    {
      headerName: "advertiser Name",
      flex: width > 766 ? 1 : null,
      field: "advertiserName",
      //filter: true,
      filter: "agTextColumnFilter",

      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
    },
    {
      headerName: "Environment",
      flex: width > 766 ? 1 : null,
      field: "environment",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
    },
    {
      headerName: "Campaign Id",
      flex: width > 766 ? 1 : null,
      field: "campaignId",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
    },
    {
      headerName: "Campaign Name",
      flex: width > 766 ? 1 : null,
      field: "campaignName",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
    },

    {
      headerName: "In app RTB",
      flex: width > 766 ? 1 : null,
      field: "inappRtbCap",
      filter: true,
      //filter: "agTextColumnFilter",
      floatingFilter: "agTextColumnFilter",
      minWidth: 150,
      headerClass: "my-header-class",
      //editable: true,
      filterParams: {
        buttons: ["apply", "reset"],
        closeOnApply: true,
      },
      cellRenderer: BtnCellRenderer,
      // cellRendererParams: {
      //   clicked: function (field) {
      //     alert(`${field} was clicked`);
      //   },
      // },
    },
  ]);

  // DefaultColDef sets props common to all Columns
  const defaultColDef = useMemo(() => ({
    sortable: true,
  }));
  // Example of consuming Grid Event
  const cellClickedListener = useCallback((event) => {
    console.log("cellClicked", event);
  }, []);

  // Example using Grid's API
  const buttonListener = useCallback((e) => {
    gridRef.current.api.deselectAll();
  }, []);
  var ragCellClassRules = {
    "rag-green-outer": function (params) {
      return params.value === 2008;
    },
    "rag-amber-outer": function (params) {
      return params.value === 2004;
    },
    "rag-red-outer": function (params) {
      return params.value === 2000;
    },
  };
  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    // console.log(rowData);
    setGridApi(params.api);
  };

  const getRowHeight = (params) => (params.node.group ? 40 : 40);

  const sumRow = {
    advertiserName: "Total",

    inappRtbCap: SendDataToFirstTable.reduce(
      (acc, curr) => acc + curr.inappRtbCap,
      0
    ),
  };
  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.rowPinned === "bottom") {
        return { backgroundColor: "#f9f8f9" };
      }
    },
    rowClass: (params) => {
      return params.node.rowIndex === SendDataToFirstTable.length
        ? "bottom-row"
        : "";
    },
  };

  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const containerStyle = useMemo(
    () => ({ width: "100%", height: screenHeight - 130 }),
    []
  );
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);
  useEffect(() => {
    // This code will run only when myVariable changes
    console.log(`startDate changed to ${startDate} ---- ${endDate}`);
  }, [startDate, endDate]);
  const frameworkComponents = {
    actionsCellRenderer: ActionsCellRenderer,
  };

  const items = localStorage.getItem("Token");
  const trimmedMyaa = items.substring(1, items.length - 1);
  const aa = trimmedMyaa.replace("?jwt=", "");
  const UpdateRtbItems = async (event) => {
    setLoading(false);
    setLoadingUpdateRtbItemsButton(false);
    const sss = [changes];
    const changesArray = Object.entries(changes).map((entry) => entry[1]);

    console.log(changes);
    console.log(sss);
    console.log(changesArray);

    //setLoading1(false);
    try {
      const response = await axios.post(
        `https://dsp-api.o2rintelligence.com/api/Dashboard/UpdateRtbItems`,
        changesArray,
        {
          headers: {
            Authorization: `Bearer ${aa}`,
          },
        }
      );
      console.log(response.data);
      //console.log(SendDataToFirstTable);
      //setLoading1(true);
      setLoading(true);
      setLoadingUpdateRtbItemsButton(true);
    } catch (error) {
      console.log("error in UpdateRtbItems");
    }
  };
  return (
    <div style={{ paddingBottom: 30 }}>
      {Loading ? <></> : <>loading...</>}
      <div style={containerStyle}>
        <div style={gridStyle} className="ag-theme-alpine">
          <span style={{ color: "#1a1523", fontSize: 18 }}>RTB Management</span>
          <AgGridReact
            cellClassRules={ragCellClassRules}
            ref={gridRef} // Ref for accessing Grid's API
            rowData={SendDataToFirstTable} // Row Data for Rows //{[...SendDataToFirstTable, sumRow]} add another column had a total values
            columnDefs={columnDefs} // Column Defs for Columns
            defaultColDef={defaultColDef} // Default Column Properties
            animateRows={true} // Optional - set to 'true' to have rows animate when sorted
            rowSelection="multiple" // Options - allows click selection of rows
            onCellClicked={cellClickedListener} // Optional - registering for Grid Event
            onGridReady={onGridReady}
            gridOptions={gridOptions}
            suppressScrollOnNewData={true}
            getRowHeight={getRowHeight}
            //domLayout="autoHeight"
            pagination={true}
            paginationPageSize={100}
            frameworkComponents={frameworkComponents}
            onCellValueChanged={onCellValueChanged}
            pinnedBottomRowData={[sumRow]}
          />
          {/* <button onClick={saveChanges}>Save Changes</button> */}
          {/* <button onClick={UpdateRtbItems}>Do The Change</button> */}
          {LoadingUpdateRtbItemsButton ? (
            <>
              <button
                onClick={UpdateRtbItems}
                style={{
                  borderWidth: 0,
                  borderRadius: 5,
                  backgroundColor: "#c7d2fe",
                  padding: 8,
                  cursor: "pointer",
                }}
              >
                Update changed item's
              </button>
            </>
          ) : (
            <>
              <h5>loading</h5>
            </>
          )}
        </div>{" "}
      </div>{" "}
      <style>
        {`
                      .ag-theme-alpine .ag-root-wrapper {
                        border: none;
                      }
                    `}
        {`
                      .my-header-class {
                        background-color: white;
                      }
                    `}
        {`
               .ag-header-cell {
                background-color: white;
            }`}
      </style>
    </div>
  );
}

const ActionsCellRenderer = (props) => {
  const handleButtonClick = () => {
    // Add your button click logic here
    console.log(`Button clicked for row with ID: ${props.data.id}`);
  };

  return <button onClick={handleButtonClick}>Click Me</button>;
};
